import { render } from "./CreateWallet.vue?vue&type=template&id=5c445b0f&scoped=true"
import script from "./CreateWallet.vue?vue&type=script&lang=js"
export * from "./CreateWallet.vue?vue&type=script&lang=js"

import "./CreateWallet.vue?vue&type=style&index=0&id=5c445b0f&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/front/intranet-gpaie/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c445b0f"]])

export default __exports__